import {useCallback} from 'react';
import {useNotify} from 'react-admin';
import {maxFileSize} from '../../config/const';

// What an image input says when it refuses what was dropped or chosen (react-dropzone's onDropRejected): more than
// one file at once, a file over the size limit, or a file the browser does not report as an image.
export const imageRejectionMessage = (label: string, files: File[]) => {
    if (files.length > 1) {
        return `${label} は画像を 1 枚だけ選んでください`;
    }
    if (files.some(file => file.size > maxFileSize)) {
        return `${label} は ${maxFileSize / 1000000}MB(${maxFileSize.toLocaleString('ja-JP')} バイト)以下の画像を選んでください`;
    }
    return `${label} は画像ファイル(JPEG・PNG など)を選んでください`;
};

export const useImageRejectionNotify = (label: string) => {
    const notify = useNotify();
    return useCallback((files: File[]) => {
        const message = imageRejectionMessage(label, files);
        notify(message, 'warning', {_: message});
    }, [notify, label]);
};
